import * as XLSX from 'xlsx';

const DownloadCustomerLedgerReportExcel = (reportData, companyName, setOpenBackdrop) => {
    if (!reportData || reportData.length === 0) {
        alert("No data found to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        const rows = [];
        
        // --- Header Section ---
        rows.push([companyName.toUpperCase()]);
        rows.push(["Site Stock Report"]);
        rows.push([`Generated on: ${new Date().toLocaleString()}`]);
        rows.push([]); // Spacer

        // --- Table Headers ---
        const tableHeaders = [
            "Site Name", 
            "Address", 
            "Item Name", 
            "Unit", 
            "Opening Qty", 
            "InWard Qty", 
            "OutWard Qty", 
            "Total Qty"
        ];
        rows.push(tableHeaders);

        // --- Data Filling ---
        reportData.forEach((customer) => {
            customer.items.forEach((item, index) => {
                rows.push([
                    index === 0 ? customer.customer_name : "",
                    index === 0 ? customer.customer_address : "",
                    item.item_name,
                    item.item_unit,
                    Number(item.opening_qty),
                    Number(item.challan_qty),
                    Number(item.credit_qty),
                    Number(item.total_qty)
                ]);
            });
            // Add an empty row after each customer for better readability
            rows.push([]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Ledger");

        // Column Widths
        const wscols = [
            { wch: 25 }, // Customer Name
            { wch: 30 }, // Address
            { wch: 35 }, // Item Name
            { wch: 10 }, // Unit
            { wch: 12 }, // Opening
            { wch: 12 }, // Challan
            { wch: 12 }, // Credit
            { wch: 15 }, // Total
        ];
        worksheet['!cols'] = wscols;

        XLSX.writeFile(workbook, `Stock_Ledger_Report_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Error:", error);
        alert("Excel file banane mein error aaya!");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadCustomerLedgerReportExcel;